import React, { ReactNode } from 'react';
import { Skeleton } from 'antd';
import { SkeletonInputProps as SkeletonInputCopyProps } from 'antd/lib/skeleton/Input';

export type SkeletonInputProps = SkeletonInputCopyProps & {
  children?: ReactNode;
};

const ProSkeletonInput: React.FC<SkeletonInputProps> = (props) => {
  const { children, ...resProps } = props;

  return <Skeleton.Input {...resProps}>{children}</Skeleton.Input>;
};

export default ProSkeletonInput;
